<template>
  <v-container fluid>
    <v-card class="mx-2">
      <v-data-table
        v-model="selectedAlumnosCorreo"
        :headers="headers"
        :items="obtainListaAlumnos"
        :loading="fetching"
        item-key="codigoUNI"
        :show-select="showEnviarCorreo"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Lista de Usuarios UNI</v-toolbar-title>
            <v-btn
              dark
              class="mx-4"
              color="green"
              @click="exportToExcel"
              v-if="isAdminManager"
            >
              <v-icon left>mdi-file-excel</v-icon>Exportar
            </v-btn>
            <v-btn
              :color="showEnviarCorreo ? 'error' : 'indigo'"
              :disabled="fetching"
              :dark="!fetching"
              :text="showEnviarCorreo"
              @click="startEnviarCorreo"
              ><v-icon left>{{
                showEnviarCorreo ? 'mdi-close' : 'mdi-email-plus-outline'
              }}</v-icon
              >{{
                showEnviarCorreo
                  ? 'Cancelar Envío de Correo'
                  : 'Crear Nuevo Correo'
              }}</v-btn
            >
            <v-spacer></v-spacer>

            <v-btn icon color="success" class="mx-2" @click="queryParamsFetch">
              <v-icon>mdi-reload</v-icon>
            </v-btn>
          </v-toolbar>
          <v-layout class="py-0 px-4 d-flex flex-column">
            <v-row>
              <v-col cols="12" sm="12" md="2">
                <v-text-field
                  label="Buscar"
                  v-model="searchText"
                  append-icon="mdi-magnify"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-text-field
                  label="Desde Código"
                  v-model="codigoDesde"
                  append-icon="mdi-arrow-up-circle"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-text-field
                  label="Hasta Código"
                  v-model="codigoHasta"
                  append-icon="mdi-arrow-down-circle"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-text-field
                  label="Período de Egreso (Separado por comas)"
                  v-model="periodoEgreso"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-autocomplete
                  v-model="especialidadSeleccionada"
                  :items="listaCarreras"
                  item-text="nombreEspecialidad"
                  item-value="codigoEspecialidad"
                  outlined
                  chips
                  dense
                  label="Especialidad"
                  multiple
                >
                  <template v-slot:selection="data">
                    <v-chip small>
                      {{ data.item.codigoEspecialidad }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-select
                  dense
                  outlined
                  label="Estado de Alumno"
                  :items="itemsStatusAlumno"
                  v-model="statusAlumno"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-select
                  dense
                  outlined
                  label="Nivel"
                  :items="itemsLevelAlumno"
                  v-model="levelAlumno"
                ></v-select>
              </v-col>
            </v-row>
          </v-layout>
          <v-layout class="py-0 px-4 d-flex flex-column">
            <EnvioCorreoForm
              :show.sync="showEnviarCorreo"
              @send-mail="onSendMail"
            ></EnvioCorreoForm>
            <transition name="fade">
              <div class="d-flex justify-space-between" v-if="showEnviarCorreo">
                <v-checkbox
                  label="Seleccionar Todos"
                  v-model="todosAlumnosSelected"
                  @change="onSeleccionarTodosBtn"
                ></v-checkbox>
                <p>{{ selectedAlumnosCorreo.length }} personas seleccionadas</p>
              </div>
            </transition>
          </v-layout>
        </template>
        <template v-slot:item.nombres="{ item }">
          {{ item.nombres }} {{ item.apellidoPaterno }}
          {{ item.apellidoMaterno }}
        </template>
        <template v-slot:item.infoContacto="{ item }">
          {{
            item.infoContacto
              ? item.infoContacto.celular
                ? item.infoContacto.celular.valor
                : '-'
              : '-'
          }}
        </template>
        <template v-slot:item.estado="{ item }">
          <v-chip
            class="ma-2"
            :color="
              item.estado
                ? item.estado === 'ACTIVO'
                  ? 'success'
                  : 'error'
                : 'error'
            "
            text-color="white"
          >
            {{ item.estado ? item.estado : 'INACTIVO' }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon color="blue" class="mx-2" @click="openAlumnoInfo(item)">
            mdi-account-search
          </v-icon>
          <v-icon color="green" class="mx-2" @click="editAlumno(item)"
            >mdi-account-edit</v-icon
          >
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as debounce from '@/utils/debounce.js';
import xlsx from 'xlsx';

export default {
  components: {
    EnvioCorreoForm: () => import('@/components/admin/forms/EnvioCorreoForm.vue')
  },
  data () {
    return {
      searchText: '',
      codigoDesde: '',
      codigoHasta: '',
      periodoEgreso: '',
      statusAlumno: 'ACTIVO',
      levelAlumno: '',
      periodoEgresoDebounced: '',
      especialidadSeleccionada: null,
      filters: {
        q: '',
        initCode: '',
        endCode: '',
        graduationYear: '',
        careers: [],
        status: 'ACTIVO'
      },
      filtersInit: {
        q: '',
        initCode: '',
        endCode: '',
        graduationYear: '',
        careers: [],
        status: ''
      },
      headers: [
        {
          text: 'Nombres',
          align: 'left',
          value: 'nombres',
          width: 180
        },
        { text: 'Correo UNI', value: 'correoUNI' },
        { text: 'Correo Alternativo', value: 'correoAlternativo' },
        { text: 'Código', value: 'codigoUNI' },
        { text: 'Nivel', value: 'estadoAcademicoAlumno' },
        { text: 'Egreso', value: 'periodoEgreso' },
        {
          text: 'Especialidad',
          value: 'carrera.codigoEspecialidad',
          align: 'center'
        },
        { text: 'Celular', value: 'infoContacto' },
        { text: 'Estado', value: 'estado', align: 'center' },
        { text: 'Acciones', value: 'actions', sortable: false, align: 'center' }
      ],
      showEnviarCorreo: false,
      selectedAlumnosCorreo: [],
      todosAlumnosSelected: false,
      itemsStatusAlumno: [
        {
          text: 'Solo Activos',
          value: 'ACTIVO'
        },
        {
          text: 'Solo Inactivos',
          value: 'INACTIVO'
        },
        {
          text: 'Mostrar Todos',
          value: ''
        }
      ],
      itemsLevelAlumno: [ // 'BACHILLER', 'EGRESADO', 'TITULADO'
        {
          'text': 'Bachiller',
          'value': 'BACHILLER'
        },
        {
          'text': 'Egresado',
          'value': 'EGRESADO'
        },
        {
          'text': 'Titulado',
          'value': 'TITULADO'
        },
        {
          'text': 'Mostrar Todos',
          'value': ''
        }
      ]
    };
  },

  methods: {
    editAlumno (data) {
      this.setSelectedAlumnoEdit({ ...data });
      this.setEditAlumnoDialog(true);
    },

    async openAlumnoInfo (data) {
      this.setShowAlumnoInfoDialog(true);
      if (this.getSelectedAlumnoInfo) {
        if (data.codigoUNI !== this.getSelectedAlumnoInfo) {
          await this.fetchGetAlumnoInformation(data.codigoUNI);
        }
      } else {
        await this.fetchGetAlumnoInformation(data.codigoUNI);
      }
    },

    exportToExcel () {
      let list = [...this.obtainListaAlumnos];
      let resource = list.map((obj) => {
        return {
          codigoUNI: obj.codigoUNI,
          nombres: obj.nombres,
          apellidoPaterno: obj.apellidoPaterno,
          apellidoMaterno: obj.apellidoMaterno,
          correoUNI: obj.correoUNI,
          correoAlternativo: obj.correoAlternativo,
          estadoAcademicoAlumno: obj.estadoAcademicoAlumno,
          celular: obj.celular
        };
      });
      let dataExported = xlsx.utils.json_to_sheet(resource);
      dataExported['A1'].v = 'Código UNI';
      dataExported['B1'].v = 'Nombres';
      dataExported['C1'].v = 'Apellido Paterno';
      dataExported['D1'].v = 'Apellido Materno';
      dataExported['E1'].v = 'Correo UNI';
      dataExported['F1'].v = 'Correo Alternativo';
      dataExported['G1'].v = 'Nivel Académico';
      dataExported['H1'].v = 'Celular';

      const workbook = xlsx.utils.book_new();
      const fileName = `${new Date().getTime()}-listaAlum`;
      xlsx.utils.book_append_sheet(workbook, dataExported, fileName);
      xlsx.writeFile(workbook, `${fileName}.xlsx`);
    },

    async queryParamsFetch () {
      if (this.isFiltered) {
        await this.fetchListaAlumnosUNI();
      } else {
        await this.fetchListaAlumnosUNIquery(this.filters);
      }
      this.onSeleccionarTodosBtn();
    },

    async onSendMail (mailForm) {
      if (this.obtainListaAlumnos.length !== this.selectedAlumnosCorreo.length) {
        mailForm.filters = {};
        mailForm.filters.alumnosSeleccionados = this.selectedAlumnosCorreo.map(
          function (i) {
            return {
              correoUNI: i.correoUNI,
              correoAlternativo: i.correoAlternativo
            };
          }
        );
      } else {
        mailForm.filters = { ...this.filters };
      }

      let success = await this.fetchEnviarNuevoCorreo(mailForm);
      if (success) {
        this.selectedAlumnosCorreo = [];
        this.todosAlumnosSelected = false;
        this.showEnviarCorreo = false;

        mailForm.asunto = '';
        mailForm.cuerpo = '';
        mailForm.adjunto = null;
      }
    },

    onSeleccionarTodosBtn () {
      if (this.todosAlumnosSelected) {
        this.selectedAlumnosCorreo = this.getRawObject(this.obtainListaAlumnos);
      } else {
        this.selectedAlumnosCorreo = [];
      }
    },

    async startEnviarCorreo () {
      this.todosAlumnosSelected = !this.showEnviarCorreo;
      this.showEnviarCorreo = !this.showEnviarCorreo;
      this.onSeleccionarTodosBtn();
    },

    ...mapActions('admin', [
      'fetchListaAlumnosUNI',
      'fetchListaAlumnosUNIquery',
      'fetchEnviarNuevoCorreo',
      'fetchGetAlumnoInformation'
    ]),

    ...mapMutations('admin', [
      'setSelectedAlumnoEdit',
      'setEditAlumnoDialog',
      'setShowAlumnoInfoDialog'
    ])
  },

  computed: {
    isFiltered () {
      let o1 = JSON.parse(JSON.stringify(this.filters));
      let o2 = JSON.parse(JSON.stringify(this.filtersInit));

      for (let p in o1) {
        if (o1.hasOwnProperty(p)) {
          if (o1[p] !== o2[p]) {
            return false;
          }
        }
      }
      for (let p in o2) {
        if (o2.hasOwnProperty(p)) {
          if (o1[p] !== o2[p]) {
            return false;
          }
        }
      }
      return true;
    },

    obtainListaAlumnos () {
      return this.getListaAlumnosUNI.length ? [...this.getListaAlumnosUNI] : [];
    },

    dialogOpen () {
      return this.getEditAlumnoDialog;
    },

    listaCarreras () {
      if (this.isAdminManager) return this.getListaCarreras;
      let especialidad = this.getAdminData
        ? this.getAdminData.adminType.toUpperCase()
        : '';
      return this.getListaCarreras.filter(
        (item) => item.codigoFacultad.toUpperCase() === especialidad
      );
    },

    ...mapGetters('admin', [
      'getEditAlumnoDialog',
      'getNoChangeEdit',
      'getListaAlumnosUNI',
      'getSelectedAlumnoInfo',
      'isAdminManager',
      'getAdminData'
    ]),

    ...mapGetters('user', ['fetching', 'getListaCarreras']),
    ...mapGetters('admin', ['isAdminManager'])
  },

  watch: {
    searchText: debounce.debounce(async function (newVal) {
      this.filters.q = newVal;
      await this.queryParamsFetch();
    }, 750),

    codigoDesde: debounce.debounce(async function (newVal) {
      this.filters.initCode = newVal;
      await this.queryParamsFetch();
    }, 500),

    codigoHasta: debounce.debounce(async function (newVal) {
      this.filters.endCode = newVal;
      await this.queryParamsFetch();
    }, 500),

    periodoEgreso: debounce.debounce(async function (newVal) {
      this.filters.graduationYear = newVal;
      await this.queryParamsFetch();
    }, 500),

    especialidadSeleccionada: debounce.debounce(async function (newVal) {
      this.filters.careers = newVal;
      await this.queryParamsFetch();
    }, 750),

    statusAlumno: debounce.debounce(async function (newVal) {
      this.filters.status = newVal;
      await this.queryParamsFetch();
    }),

    levelAlumno: debounce.debounce(async function (newVal) {
      this.filters.level = newVal;
      await this.queryParamsFetch();
    }),

    dialogOpen: async function (newVal) {
      if (newVal === false && this.getNoChangeEdit === false) {
        await this.queryParamsFetch();
      }
    }
  },

  async mounted () {
    await this.queryParamsFetch();
  }
};
</script>

<style>
.fade-enter-active {
  transition: opacity 1s;
}

.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
